var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextButtonA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 14,
    viewBox: "0 0 33 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Text_Button",
    "data-name": "Text Button",
    transform: "translate(29 11)",
    fill: "#2067ed",
    fontSize: 10,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28,
    y: 0
  }, "\u0632\u0631 \u0646\u0635\u064A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextButtonA);
export default __webpack_public_path__ + "static/media/TextButtonA.de2ad8c3d56f7db0334e3b7d5a6dcd51.svg";
export { ForwardRef as ReactComponent };